$(function () {
    // Module Slider using Splide slider
    var splides = document.querySelectorAll('.plt__section .splide')

    if (splides.length > 0) {
        var splide = new Splide('.plt__section .splide', {
            padding: { left: '10px', right: '50px' },
            perPage: 1,
            trimSpace: false,
            mediaQuery: 'min',
            breakpoints: {
                768: {
                    padding: { left: '10%', right: '10%' },
                    start: 0,
                    focus: 0,
                    perPage: 2,
                },
                1024: {
                    perPage: 3,
                },
            },
        })

        splide.on('mounted', () => {
            setTimeout(() => {
                const slider = document.querySelector('.plt__section .splide')
                const footers = slider.querySelectorAll('.plt__footer')
                let max_h_cta = 0
                let max_h_txt = 0

                footers.forEach((footer) => {
                    const cta = footer.querySelector('.plt__footer--cta')
                    const txt = footer.querySelector('.plt__footer--txt')
                    if (cta && txt) {
                        cta.style.height = 'auto'
                        txt.style.height = 'auto'
                    }
                })

                footers.forEach((footer) => {
                    const cta = footer.querySelector('.plt__footer--cta')
                    const txt = footer.querySelector('.plt__footer--txt')
                    if (cta && txt) {
                        max_h_cta = Math.max(max_h_cta, cta.offsetHeight)
                        max_h_txt = Math.max(max_h_txt, txt.offsetHeight)
                    }
                })

                footers.forEach((footer) => {
                    const cta = footer.querySelector('.plt__footer--cta')
                    const txt = footer.querySelector('.plt__footer--txt')

                    if (cta && txt) {
                        cta.style.height = `${max_h_cta}px`
                        txt.style.height = `${max_h_txt}px`
                    }
                })
            }, 500)
        })

        splide.mount()
    }
})
